import React, { useContext, useState } from 'react';
import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const DocumentsContext = React.createContext();

export const DocumentsProvider = ({ children }) => {
  const [nominationDocuments, setNomDocs] = useState([]);
  const [mainDocuments, setMainDocs] = useState([]);

  const clearNomClaims = () => {
    setNomDocs([]);
  };

  //   const refreshClaimById = async (claimId) => {
  //     await axios(`${baseUrl}/api/claims/getClaimById?claimId=${claimId}`).then(
  //       (result) => {
  //         console.log('returned claim info in context', result);
  //         setCurrentClaim(result.data.result);
  //       },
  //       (error) => {
  //         alert('failed');
  //       }
  //     );
  //   };

  const populateNomDocuments = async (refId) => {
    const response = await fetch(
      `${baseUrl}/api/client/getDocumentByDependantRefId?refId=${refId}`
    );
    const data = await response.json();
    if (data.result.length > 0) {
      setNomDocs(data.result);
    } else {
      setNomDocs([]);
    }
  };

  const populateMainDocuments = async (refId) => {
    const response = await fetch(`${baseUrl}/api/client/GetDocumentsByClient?clientrefId=${refId}`);
    const data = await response.json();
    console.log('documents data received 22200', data);
    // if (data.result.length > 0) {
    console.log('documents data received 33300', data.result);
    setMainDocs(data.result);
    // } else {
    //   console.log('documents data received 323', data.result);
    //   setNomDocs([]);
    // }
  };

  return (
    <DocumentsContext.Provider
      value={{
        populateNomDocuments,
        nominationDocuments,
        setNomDocs,
        clearNomClaims,
        mainDocuments,
        setMainDocs,
        populateMainDocuments
      }}
    >
      {children}
    </DocumentsContext.Provider>
  );
};

export const useDocumentsContext = () => useContext(DocumentsContext);
